var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"reportLabel"},[_vm._v("Indicator "+_vm._s(_vm.indicator.number)+": "+_vm._s(_vm.indicator.text))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.indicator.comments)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }